import refineSearchTimeTemplate from './refineSearchTime.html';
import refineSearchController from './RefineSearchTimeController';

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template: refineSearchTimeTemplate,
    controller: 'RefineSearchTimeController'
  };
}

export default function (ngModule) {
  ngModule.directive('refineSearchTime', [directive]);
  refineSearchController(ngModule);
}
